import { createStyles, makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useSortLabelStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '&.MuiTableSortLabel-root': {
        color: 'white',
      },
      '&.MuiTableSortLabel-root:hover': {
        color: 'white',
        fontWeight: 700,
      },
      '&.Mui-active': {
        color: 'white',
      },
      '& .MuiTableSortLabel-icon': {
        color: 'white !important',
      },
    },
  })
);

export default useSortLabelStyles;
